import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "alertRibbonDismissedCount"

export default class extends Controller {
  static values = { count: Number }

  connect() {
    const dismissedAt = localStorage.getItem(STORAGE_KEY)
    if (dismissedAt && parseInt(dismissedAt, 10) === this.countValue) {
      this.#hide()
    }
  }

  dismiss() {
    localStorage.setItem(STORAGE_KEY, this.countValue)
    this.element.style.transition = "max-height 0.3s cubic-bezier(0.16,1,0.3,1), opacity 0.25s ease"
    this.element.style.maxHeight = this.element.offsetHeight + "px"
    this.element.style.overflow = "hidden"

    requestAnimationFrame(() => {
      this.element.style.maxHeight = "0"
      this.element.style.opacity = "0"
      this.element.style.borderBottomWidth = "0"
    })
  }

  #hide() {
    this.element.style.display = "none"
  }
}
